import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  affiliate: null,
};

const reducers = {
  setAffiliate: (state, { payload }) => ({
    ...state,
    affiliate: payload,
  }),
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'authentication',
  reducers,
});

export const { setAffiliate } = actions;

export const updateAffiliate = affiliate => dispatch => {
  return dispatch(setAffiliate(affiliate));
};

export default reducer;
